<template>
	<div class="container">
		<div class="header" :style="{ background: `rgba(255, 240, 238,${headerOpacity})` }">
			<div class="location" @click="showCityPicker = true">
				<img src="@/assets/home/location.svg" class="location-icon" />
				<!-- city -->
				<span>{{ currentCityText }}</span>
				<img src="@/assets/home/more_location.svg" class="more-location-icon" />
			</div>
			<div class="search" @click="goToSearch">
				<img src="@/assets/home/search.svg" alt="" />
				<!-- 搜索 -->
				<span class="search-input">{{ $t("home.search") }}</span>
			</div>
			<LanguageSwitch />
		</div>
		<div class="my-banner">
			<img src="@/assets/home/banner.png" alt="" />
			<div class="banner-text">
				<div class="banner-text-title">
					<img src="@/assets/home/crown.svg" alt="" />
					<!-- pandapass -->
					<span>{{ $t("home.pandapass") }}</span>
				</div>
				<!-- 覆盖近30个景点，一次游览即可回本！ -->
				<div class="banner-text-content">{{ $t("home.bannerDescription") }}</div>
				<div class="banner-text-button">
					<van-button @click="goBuyVip">{{ $t("home.buyBtn") }}</van-button>
				</div>
			</div>
		</div>
		<div class="content">
			<div class="tabbar" :class="{ 'sticky-active': isTabbarSticky }">
				<div class="bar">
					<!-- 热门景点 -->
					<div :class="{ active: active === 0 }" @click="active = 0">{{ $t("home.hotScenicSpot") }}</div>
					<!-- 生活方式 -->
					<div :class="{ active: active === 1 }" @click="active = 1">{{ $t("home.liveStyle") }}</div>
				</div>
				<div class="filter" v-show="active === 1" :show="show" @click="show == false ? (show = true) : (show = false)">
					<!-- 筛选 -->
					<span>{{ $t("home.filter") }}</span>
					<img src="@/assets/home/filter.svg" alt="" />
				</div>
			</div>
			<van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
				<van-picker :columns="filterColumns" @confirm="onFilterConfirm" @cancel="onFilterCancel" :title="$t('home.filter')" :confirm-button-text="$t('home.picker_confirm')" :cancel-button-text="$t('home.picker_cancel')" show-toolbar />
			</van-popup>
			<van-popup v-model="showCityPicker" position="bottom" :style="{ height: '40%' }">
				<van-picker :columns="cityColumns" @confirm="onCityConfirm" @cancel="onCityCancel" :title="$i18n.locale === 'zh' ? '选择城市' : 'Select City'" :confirm-button-text="$t('home.picker_confirm')" :cancel-button-text="$t('home.picker_cancel')" show-toolbar />
			</van-popup>
			<van-pull-refresh v-model="refreshLoading" @refresh="onRefresh" :pulling-text="$t('refresh.pulling')" :loosing-text="$t('refresh.loosing')" :loading-text="$t('refresh.loading')">
				<van-tabs v-model="active" sticky>
					<van-tab>
						<div class="list" v-if="attractions.hot.length > 0">
							<div class="waterfall-container">
								<div class="waterfall-column">
									<div class="attraction-card" v-for="(item, index) in waterfallColumns.hot[0]" :key="`left-${index}`" @click="goToDetail(item)">
										<div class="card-image">
											<van-image lazy-load :src="item.cover" :alt="item[`title_${$i18n.locale}`]" />
										</div>
										<div class="card-content">
											<h3 class="card-title">{{ item[`title_${$i18n.locale}`] }}</h3>
											<div class="card-price">
												<!-- 免费 -->
												<span v-if="item.currentPrice === '0.00'" class="free-price">{{ $t("home.free") }}</span>
												<span v-else class="current-price">
													<span class="symbol">¥</span>
													{{ item.currentPrice }}
												</span>
												<!-- 原价： -->
												<span v-if="item.originalPrice !== '0.00'" class="original-price">¥{{ item.originalPrice }}</span>
											</div>
										</div>
									</div>
								</div>
								<div class="waterfall-column">
									<div class="attraction-card" v-for="(item, index) in waterfallColumns.hot[1]" :key="`right-${index}`" @click="goToDetail(item)">
										<div class="card-image">
											<van-image lazy-load :src="item.cover" :alt="item[`title_${$i18n.locale}`]" />
										</div>
										<div class="card-content">
											<h3 class="card-title">{{ item[`title_${$i18n.locale}`] }}</h3>
											<div class="card-price">
												<!-- 免费 -->
												<span v-if="item.currentPrice === '0.00'" class="free-price">{{ $t("home.free") }}</span>
												<span v-else class="current-price">
													<span class="symbol">¥</span>
													{{ item.currentPrice }}
												</span>
												<!-- 原价： -->
												<span v-if="item.originalPrice !== '0.00'" class="original-price">¥{{ item.originalPrice }}</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="no-data" v-else>
							<van-empty class="custom-image" image="https://img01.yzcdn.cn/vant/custom-empty-image.png" :description="$t('home.noData')" />
						</div>
					</van-tab>
					<van-tab>
						<div class="list" v-if="attractions.live.length > 0">
							<div class="waterfall-container">
								<div class="waterfall-column">
									<div class="attraction-card" v-for="(item, index) in waterfallColumns.live[0]" :key="`left-${index}`" @click="goToDetail(item)">
										<div class="card-image">
											<van-image lazy-load :src="item.cover" :alt="item[`title_${$i18n.locale}`]" />
										</div>
										<div class="card-content">
											<h3 class="card-title">{{ item[`title_${$i18n.locale}`] }}</h3>
											<div class="card-price">
												<!-- 免费 -->
												<span v-if="item.currentPrice === '0.00'" class="free-price">{{ $t("home.free") }}</span>
												<span v-else class="current-price">
													<span class="symbol">¥</span>
													{{ item.currentPrice }}
												</span>
												<!-- 原价： -->
												<span v-if="item.originalPrice !== '0.00'" class="original-price">¥{{ item.originalPrice }}</span>
											</div>
										</div>
									</div>
								</div>
								<div class="waterfall-column">
									<div class="attraction-card" v-for="(item, index) in waterfallColumns.live[1]" :key="`right-${index}`" @click="goToDetail(item)">
										<div class="card-image">
											<van-image lazy-load :src="item.cover" :alt="item[`title_${$i18n.locale}`]" />
										</div>
										<div class="card-content">
											<h3 class="card-title">{{ item[`title_${$i18n.locale}`] }}</h3>
											<div class="card-price">
												<!-- 免费 -->
												<span v-if="item.currentPrice === '0.00'" class="free-price">{{ $t("home.free") }}</span>
												<span v-else class="current-price">
													<span class="symbol">¥</span>
													{{ item.currentPrice }}
												</span>
												<!-- 原价： -->
												<span v-if="item.originalPrice !== '0.00'" class="original-price">¥{{ item.originalPrice }}</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="no-data" v-else>
							<van-empty class="custom-image" image="https://img01.yzcdn.cn/vant/custom-empty-image.png" :description="$t('home.noData')" />
						</div>
					</van-tab>
				</van-tabs>
			</van-pull-refresh>
		</div>
	</div>
</template>

<script>
import { getToken, requireLogin } from "@/utils/auth.js";
export default {
	computed: {
		currentCityText() {
			return this.currentCityTextGetter();
		},
	},
	data() {
		return {
			stickyEl: null,
			stickyTop: "0.00",
			container: null,
			refreshLoading: false,
			active: "0.00",
			headerOpacity: "0.00",
			scrollHeight: 200,
			isTabbarSticky: false,
			userInfo: null,
			category: [],
			attractions: {
				hot: [],
				live: [],
			},
			waterfallColumns: {
				hot: [[], []], // 左右两列
				live: [[], []],
			},
			filterColumns: [],
			selectedFilter: "all",
			show: false,
			// 城市选择
			showCityPicker: false,
			cityColumns: [],
			selectedCity: "hangzhou",
			allAttractions: {
				live: [],
				hot: [],
			},
		};
	},
	mounted() {
		this.stickyEl = document.querySelector(".tabbar");
		this.stickyTop = parseInt(getComputedStyle(this.stickyEl).top, 10);
		this.container = document.querySelector(".container");
		this.initScrollListener();
		this.initFilterColumns();
		this.initCityColumns();
		this.getData();
		this.loadUserInfo();
	},
	activated() {
		// 页面被激活时调用（从其他页面返回时）
		console.log("Home页面被激活");
		// 可以在这里刷新数据或执行其他操作
		this.getData();
		// 重新绑定滚动事件监听器
		this.initScrollListener();
	},
	deactivated() {
		// 页面被停用时调用（离开页面时）
		console.log("Home页面被停用");
		// 移除滚动事件监听器，避免内存泄漏
		if (this.container) {
			this.container.removeEventListener("scroll", this.handleScroll);
		}
	},
	beforeRouteEnter(to, from, next) {
		// 路由进入前调用
		next((vm) => {
			// 可以在这里执行一些初始化操作
			console.log("进入Home页面");
		});
	},
	beforeRouteLeave(to, from, next) {
		// 路由离开前调用
		console.log("离开Home页面");
		next();
	},
	methods: {
		currentCityTextGetter() {
			const values = (this.cityColumns && this.cityColumns[0] && this.cityColumns[0].values) || [];
			const found = values.find((c) => c.value === this.selectedCity);
			return found ? found.text : "";
		},
		async loadUserInfo() {
			try {
				// 获取缓存信息
				const token = getToken();
				if (!token) return;
				const res = await this.$api.postData("/auth/user_info");
				if (res && res.code === 200) {
					this.userInfo = res.data;
					//缓存用户信息
					localStorage.setItem("userInfo", JSON.stringify(res.data));
				} else if (res && res.code === 400) {
					// 处理400错误
					console.log("用户信息获取失败:", res.msg);
					// 清除可能无效的token和用户信息
					localStorage.removeItem("token");
					localStorage.removeItem("userInfo");
					this.userInfo = null;
					// 显示错误提示
				} else if (res && res.msg) {
					console.log("其他错误:", res);
				}
			} catch (err) {
				console.error("getUserInfo error:", err);
			}
		},
		onCityConfirm(value) {
			// 适配 van-picker 传参：value 可能是数组或对象
			const picked = Array.isArray(value) ? value[0] : value;
			if (picked && picked.value) {
				this.selectedCity = picked.value;
			}
			this.showCityPicker = false;
		},
		onCityCancel() {
			this.showCityPicker = false;
		},
		onRefresh() {
			this.refreshLoading = true;
			setTimeout(() => {
				this.refreshLoading = false;
			}, 1000);
		},
		async getData() {
			try {
				const res = await this.$api.fetchData("/home/get_home_data");
				if (res && res.code === 200) {
					this.attractions.hot = res.data.hot;
					this.attractions.live = res.data.live;
					this.allAttractions.live = res.data.live;
					this.allAttractions.hot = res.data.hot;
					// 重新分配瀑布流
					await Promise.all([this.distributeWaterfall("hot"), this.distributeWaterfall("live")]);
				}
			} catch (err) {
				this.$notify({
					type: "danger",
					message: this.$t("network_error"),
				});
			}
		},
		// 混合顺序 + 最矮列优先的瀑布流分配（使用真实图片高度）
		async distributeWaterfall(type) {
			const items = this.attractions[type];
			if (!items || items.length === 0) {
				this.waterfallColumns[type] = [[], []];
				return;
			}

			// 首先显示简单的奇偶分配，避免空白
			this.waterfallColumns[type] = [items.filter((_, index) => index % 2 === 0), items.filter((_, index) => index % 2 === 1)];

			// 然后异步获取真实高度并重新分配
			try {
				const columns = [[], []];
				const columnHeights = [0, 0];

				// 预加载所有图片获取真实高度
				const itemsWithHeights = await Promise.all(
					items.map(async (item, index) => {
						const realHeight = await this.getRealImageHeight(item.cover, index);
						return { ...item, realHeight };
					})
				);

				// 循环列表：每次循环都判断左右两边高度，那边矮就放那边
				itemsWithHeights.forEach((item) => {
					// 选择高度较小的列
					const targetColumn = columnHeights[0] <= columnHeights[1] ? 0 : 1;

					// 添加到选中的列
					columns[targetColumn].push(item);
					columnHeights[targetColumn] += item.realHeight;
				});

				// 更新为真实高度的分配结果
				this.waterfallColumns[type] = columns;
			} catch (error) {
				console.warn("瀑布流高度计算失败，使用默认分配:", error);
			}
		},
		// 获取图片真实高度
		getRealImageHeight(imageUrl, index) {
			return new Promise((resolve) => {
				if (!imageUrl) {
					// 没有图片时使用基础高度
					resolve(this.getFallbackHeight(index));
					return;
				}

				const img = new Image();
				let resolved = false;

				const resolveHeight = (height) => {
					if (!resolved) {
						resolved = true;
						resolve(height);
					}
				};

				img.onload = () => {
					// 计算容器宽度（屏幕宽度的一半，减去间距）
					const containerWidth = (window.innerWidth - 48) / 2; // 48px是padding和gap

					// 根据图片真实宽高比计算显示高度
					const aspectRatio = img.height / img.width;
					const imageHeight = containerWidth * aspectRatio;

					// 加上内容区域高度（标题、价格等）
					const contentHeight = 80;
					const totalHeight = imageHeight + contentHeight;

					// 设置合理的高度范围
					const finalHeight = Math.max(150, Math.min(500, totalHeight));

					resolveHeight(finalHeight);
				};

				img.onerror = () => {
					resolveHeight(this.getFallbackHeight(index));
				};

				// 设置超时，避免图片加载时间过长
				setTimeout(() => {
					if (!img.complete) {
						resolveHeight(this.getFallbackHeight(index));
					}
				}, 2000);

				img.src = imageUrl;
			});
		},
		// 获取降级高度
		getFallbackHeight(index) {
			// 基础高度变化：200, 240, 280, 320的循环
			const baseHeight = 200;
			const contentHeight = 80;
			const variation = (index % 4) * 40; // 0, 40, 80, 120

			return baseHeight + contentHeight + variation;
		},
		// 处理滚动事件
		handleScroll(e) {
			let scrollTop = e.target.scrollTop;
			let rect = this.stickyEl.getBoundingClientRect();
			// 当元素距离视口顶部的距离等于 sticky 的 top 值时，认为“吸顶”了
			if (rect.top <= this.stickyTop) {
				this.isTabbarSticky = true;
			} else {
				this.isTabbarSticky = false;
			}

			// 计算header透明度
			if (scrollTop > this.scrollHeight) {
				this.headerOpacity = 1;
			} else {
				//按照比例计算
				this.headerOpacity = scrollTop / this.scrollHeight;
			}
		},
		goBuyVip() {
			const queryParams = { from: "index" };
			this.$router.push({ name: "package-detail", query: queryParams });
		},
		// 跳转到详情页
		goToDetail(item) {
			// 跳转到景点详情页
			this.$router.push({ name: "detail", params: { id: item.id, type: this.active } });
		},
		goToSearch() {
			this.$router.push({ name: "search", query: { from: "index" } });
		},
		async onFilterConfirm(value) {
			this.selectedFilter = value[0].value;
			if (this.selectedFilter == "all") {
				this.attractions.live = this.allAttractions.live;
			} else {
				this.attractions.live = this.allAttractions.live.filter((item) => item.category_id == this.selectedFilter);
			}
			// 重新分配瀑布流
			await this.distributeWaterfall("live");
			this.show = false;
		},
		onFilterCancel() {
			this.show = false;
		},
		initFilterColumns() {
			this.filterColumns = [
				{
					values: [
						{ text: this.$t("home.all") || "全部", value: "all" },
						{ text: this.$t("home.restaurant") || "餐饮", value: "2" },
						{ text: this.$t("home.hotel") || "酒店", value: "3" },
						{ text: this.$t("home.entertainment") || "娱乐", value: "4" },
					],
				},
			];
		},
		initCityColumns() {
			const isZh = this.$i18n && this.$i18n.locale === "zh";
			const values = [
				{ text: isZh ? "杭州" : "Hangzhou", value: "hangzhou" },
				{ text: isZh ? "成都" : "Chengdu", value: "chengdu" },
			];
			const defaultIndex = Math.max(
				0,
				values.findIndex((v) => v.value === this.selectedCity)
			);
			this.cityColumns = [
				{
					values,
					defaultIndex,
				},
			];
		},
		initScrollListener() {
			// 先移除可能存在的监听器，避免重复绑定
			if (this.container) {
				this.container.removeEventListener("scroll", this.handleScroll);
				// 重新绑定滚动事件监听器
				this.container.addEventListener("scroll", this.handleScroll);
			}
		},
	},
	watch: {
		"$i18n.locale": {
			handler() {
				this.initFilterColumns();
				this.initCityColumns();
			},
			immediate: false,
		},
	},
};
</script>

<style scoped lang="scss">
.container {
	background: url("../assets/top_bj.png") no-repeat -2px -2px;
	background-size: calc(100% + 4px) auto;
	background-color: #fff;
	padding: 0 16px;
	overflow: hidden auto;
	height: calc(100vh - 68px - env(safe-area-inset-bottom));
}

.header {
	max-width: calc(var(--maxWidth) - 32px);
	width: calc(100vw - 32px);
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 48px;
	position: sticky;
	top: 0;
	left: 0;
	right: 0;
	z-index: 100;
	transform: translateX(-16px);
	padding: 0 16px;
	backdrop-filter: blur(2px);
	-webkit-backdrop-filter: blur(2px);
	.location {
		display: flex;
		align-items: center;

		.location-icon {
			width: 14px;
		}

		.more-location-icon {
			width: 6px;
		}

		span {
			font-family: "D-DINExp-Bold";
			font-weight: bold;
			font-size: 12px;
			color: #000000;
			margin: 0 3px 0 5px;
		}
	}

	.search {
		flex: 1;
		margin: 0 15px;
		display: flex;
		align-items: center;
		background: #ffffff;
		border-radius: 20px;
		padding: 0 14px;
		height: 34px;

		.search-input {
			font-family: "D-DINExp";
			font-size: 12px;
			color: #808080;
			margin-left: 7px;
		}

		img {
			width: 15px;
			height: 15px;
		}
	}
}

.my-banner {
	width: 100%;
	position: relative;
	img {
		width: 100%;
	}

	.banner-text {
		position: absolute;
		top: 10%;
		bottom: 0;
		left: 0;
		right: 0;
		padding: 20px;
		height: fit-content;
		.banner-text-title {
			display: flex;
			align-items: center;
			font-size: 31px;
			color: #ffffff;
			margin-top: 20px;
			font-family: "D-DINExp-Bold";
			font-weight: bold;

			img {
				width: 32px;
				margin-right: 12px;
			}
		}

		.banner-text-content {
			min-height: 36px;
			margin-top: 32px;
			font-family: "D-DINExp";
			font-size: 14px;
			color: #ffffff;
			padding: 0 50px 0 0;
			line-height: 18px;
		}
		.banner-text-button {
			margin-top: 12px;
			display: flex;
			justify-content: flex-end;
			align-items: center;
			.van-button {
				border-radius: 24px;
				width: 70px;
				height: 30px;
				font-size: 12px;
				padding: 0;
				color: #eb2d16;
				background: linear-gradient(270deg, #ffbab2 0%, #ffffff 100%);
				border: transparent;
			}
		}
	}
}

.content {
	margin-top: 10px;
	position: relative;
	.tabbar {
		display: flex;
		justify-content: space-between;
		align-items: center;
		position: sticky;
		top: 48px;
		z-index: 100;
		background: rgba(255, 255, 255, 0);
		height: 48px;
		width: 100%;
		transform: translateX(-16px);
		padding: 0 16px;
		transition: all 0.3s ease;

		&.sticky-active {
			background: rgb(255, 240, 238);
		}
		.bar {
			display: flex;
			align-items: center;
			justify-content: center;

			> div:not(:last-child) {
				margin-right: 32px;
			}
			> div {
				font-family: "D-DINExp-Bold";
				font-weight: bold;
				font-size: 17px;
				color: #000000;
				position: relative;
			}
			> div.active {
				color: #eb2d16;
				font-size: 17px;
				font-family: "D-DINExp-Bold";
				font-weight: bold;

				&::after {
					content: "";
					position: absolute;
					bottom: -10px;
					left: 50%;
					transform: translateX(-50%);
					background: url("../assets/home/bar_active.svg") no-repeat center center;
					background-size: 100% 100%;
					width: 21px;
					height: 8px;
				}
			}
		}
		.filter {
			background: #f7f0f0;
			border-radius: 12px;
			display: flex;
			align-items: center;
			justify-content: center;
			font-weight: 400;
			font-size: 12px;
			color: #000000;
			padding: 0 12px;
			height: 25px;
			font-family: "D-DINExp";
			img {
				width: 9px;
				margin-left: 6px;
			}
		}
	}

	// 瀑布流布局
	.list {
		margin-top: 20px;
		padding-bottom: calc(env(safe-area-inset-bottom) + 80px);

		.waterfall-container {
			display: flex;
			gap: 12px;

			.waterfall-column {
				flex: 1;
				display: flex;
				flex-direction: column;
				gap: 12px;

				.attraction-card {
					background: #ffffff;
					border-radius: 12px;
					overflow: hidden;
					box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
					transition: all 0.3s ease;
					cursor: pointer;

					&:hover {
						transform: translateY(-2px);
						box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
					}

					.card-image {
						width: 100%;
						overflow: hidden;
						> div {
							width: 100%;
						}
						img {
							width: 100%;
							height: auto;
							display: block;
							transition: transform 0.3s ease;
						}
					}

					&:hover .card-image img {
						transform: scale(1.05);
					}

					.card-content {
						padding: 12px;

						.card-title {
							font-family: "D-DINExp-Bold";
							font-weight: bold;
							font-size: 14px;
							color: #333333;
							margin: 0 0 8px 0;
							line-height: 1.3;
							display: -webkit-box;
							-webkit-line-clamp: 2;
							line-clamp: 2;
							-webkit-box-orient: vertical;
							overflow: hidden;
							text-overflow: ellipsis;
						}

						.card-price {
							display: flex;
							justify-content: flex-start;
							align-items: flex-end;
							gap: 8px;

							.current-price {
								font-family: "D-DINExp-Bold";
								font-weight: bold;
								font-size: 17px;
								color: #eb2d16;
								font-weight: bold;
								.symbol {
									font-size: 10px;
									font-weight: 400;
									font-family: "D-DINExp";
								}
							}

							.original-price {
								font-family: "D-DINExp";
								font-size: 12px;
								color: #999999;
								text-decoration: line-through;
							}

							.free-price {
								font-family: "D-DINExp-Bold";
								font-weight: bold;
								font-size: 14px;
								color: #eb2d16;
							}
						}
					}
				}
			}
		}
	}
}
</style>
